/**
 * Created by Carsten Hibbeler
 * Copyright: xdot GmbH 2016
 */

'use strict';

import React, { useState } from 'external/react';
import { DetailsBox } from 'plugin/base-portlet';
import { CustomModal, CustomModalBody, Title, translation } from 'plugin/liferay-widgets-react-web';
import { UserHistoryEntry } from 'plugin/user-state-history-portlet';
import StateValueActions from '../actions/StateValueActions';
import StateValueLabel from '../components/StateValueLabel';
import PropTypes from 'external/prop-types';
import StateDetailsList from './StateDetailsList';

export class StatusLine extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
        };

        this.onClickDetailsBox = this.onClickDetailsBox.bind(this);
    }

    onClickDetailsBox() {
        (this.props.onClick || StateValueActions.openStatusHistory)(this.props.status);
    }

    render() {
        const { status, title } = this.props;
        return (
            <div
                 role="button"
                 className="details-box-content nomargin nopadding single clickable hyphens-auto"
                 onClick={this.onClickDetailsBox}
            >
                <StateValueLabel item={status} stateName={title && title}/><br/>
                <UserHistoryEntry userMeta={status.userMeta} timestamp={status.timestamp}/>
            </div>
        );
    }
}

function DetailsBoxStatus(props) {
    const { status } = props;
    const [ stateDescriptionDialogOpened, setStateDescriptionDialogOpened ] = useState(false);

    const onClickTitleIcon = () => {
        setStateDescriptionDialogOpened(true);
    };

    const onCloseStateDescriptionDialog = () => {
        setStateDescriptionDialogOpened(false);
    };

    let title = translation.trans(status.className + '.' + status.propName);

    if (status.className === 'ManualBooleanState') {
        title = 'Ereigniszustand';
    }
    return (
        <React.Fragment>
            <DetailsBox
                {...props}
                title={title}
                titleIcon="info-o"
                className={status.className}
                onTitleIconClick={onClickTitleIcon}
            >
                <StatusLine {...props} title={title}/>
            </DetailsBox>
            <CustomModal
                show={stateDescriptionDialogOpened}
                onHide={onCloseStateDescriptionDialog}
                size="xl"
            >
                <Title title={'Status-Beschreibung: ' + title}/>

                <CustomModalBody>
                    <StateDetailsList status={status}/>
                </CustomModalBody>

            </CustomModal>
        </React.Fragment>
    );
}

DetailsBoxStatus.propTypes = {
    status: PropTypes.object,
    title: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.string
    ]),
    onClick: PropTypes.func,
    fastEditFunc: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.bool
    ])
};
StatusLine.propTypes = DetailsBoxStatus.propTypes;

export default DetailsBoxStatus;



// WEBPACK FOOTER //
// ./js/components/DetailsBoxStatus.jsx